import { useLayoutEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useRecaptcha } from "../../../hooks/use-recaptcha";
import { LoadCaptcha } from "../../../redux/captcha/actions/default";

let loaded = false;

export const useRecaptchaLoad = () => {
    const codApplication = process.env.REACT_APP_RECAPTCHA_CODE_APPLICATION;
    const dispatch = useDispatch();

    const execute = useRecaptcha({
        sitekey: process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY,
        hideDefaultBadge: true,
    });

    const onToken = useCallback((token) => {
        dispatch(new LoadCaptcha({ token, codApplication }).create());
    }, []);

    useLayoutEffect(() => {
        const getToken = async () => {
            const token = await execute(
                process.env.REACT_APP_RECAPTCHA_DEFAULT_ACTION
            );
            loaded = true;
            onToken(token);
        };
        if (!loaded) getToken();
    }, [execute, onToken]);
};
